import { render, staticRenderFns } from "./FifthPage.vue?vue&type=template&id=8548a23c&scoped=true&"
import script from "./FifthPage.vue?vue&type=script&lang=js&"
export * from "./FifthPage.vue?vue&type=script&lang=js&"
import style0 from "./FifthPage.vue?vue&type=style&index=0&id=8548a23c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8548a23c",
  null
  
)

export default component.exports